import { useEffect } from "react";

import useAuth from "src/hooks/useAuth";

export const useIntercom = (): void => {
    const { user, userAdminId } = useAuth();

    useEffect(() => {
        if (user && !userAdminId) {
            (window as any).intercomSettings = {
                // cSpell:disable-next-line
                app_id: "tkcrhqps",
                vertical_padding: 66 + 16, // bottom bar size + 16 px
                name: `${user.firstName} ${user.lastName}`, // Full name
                email: user.email, // Email address
                created_at: user.createdDateUTC?.getTime(), // Signup date as a Unix timestamp
                user_hash: user.hashIntercom,
            };
            (window as any).Intercom("update", { hide_default_launcher: false });
        }
        return () => {
            (window as any).Intercom("update", { hide_default_launcher: true });
        };
    }, [user]);
};
